export default {
    preLoad: 1.3,
    attempt:3,
    error: require('@/assets/imgs/logo.png'), //错误时展示的图片，base64或http
    loading: require('@/assets/imgs/logo.png') //懒加载loading图
}
